window.getBase64Image =  function(image) {
  let canvas = document.createElement("canvas");
  canvas.width = image.width;
  canvas.height = image.height;
  let ctx = canvas.getContext("2d");
  ctx.drawImage(image, 0, 0, image.width, image.height);
  return canvas.toDataURL("image/jpeg");
}

class ModelZoomer extends HTMLElement {
  constructor() {
    super();

    if (window.navigator.userAgent.indexOf('Mobile') > 0) {
      return;
    }

    this.img = this.querySelector('.image-zoome-s');
    if (!this.img) {
      return;
    }
    this.zoom_src = this.img.dataset.zoomSrc;
    this.image_target = document.querySelector('.image-zoom-tg');
    this.image_data = {loaded: false, data: null, width: 0, height: 0};

    this._start = this.onStart.bind(this);
    this._move = this.onMove.bind(this);
    this._stop = this.onStop.bind(this);

    this.img.addEventListener('mouseenter', this._start);
    this.img.addEventListener('mouseleave', this._stop);
    this.img.addEventListener('mousemove', this._move);
    this.zoom_image_set = false;
  }

  onStart() {
    const img_obj = this;
    if (!img_obj.image_data.loaded) {
      img_obj.image_data.loaded = true;
      let zoom_img = new Image();
      zoom_img.setAttribute("crossOrigin",'anonymous');
      zoom_img.onload = function() {
        img_obj.image_data.width = this.width;
        img_obj.image_data.height = this.height;
        img_obj.image_data.data = window.getBase64Image(this);
        img_obj.image_target.style.backgroundImage = 'url(' + img_obj.image_data.data + ')';
        img_obj.zoom_image_set = true;
      };
      zoom_img.src = img_obj.zoom_src;
    } else if (img_obj.image_data.data) {
      img_obj.image_target.style.backgroundImage = 'url(' + img_obj.image_data.data + ')';
      img_obj.zoom_image_set = true;
    }
  }

  onMove(e) {
    const img_obj = this;
    if (img_obj.zoom_image_set) {
      img_obj.image_target.classList.remove('pre-hide');
      let posX = e.offsetX ? (e.offsetX) : e.pageX - e.target.offsetLeft;
      let posY = e.offsetY ? (e.offsetY) : e.pageY - e.target.offsetTop;
      let xRatio = (e.target.width - img_obj.image_data.width) / e.target.width;
      let yRatio = (e.target.height - img_obj.image_data.height) / e.target.height;
      img_obj.image_target.style.backgroundPosition=(-posX*-xRatio)+"px "+(-posY*-yRatio)+"px";
    }
  }

  onStop() {
    const img_obj = this;
    img_obj.image_target.classList.add('pre-hide');
    img_obj.zoom_image_set = false;
  }
}
customElements.define('model-zoomer', ModelZoomer);